import { http } from "./service.js";
const api = {
  login(data) {
    //登录
    return http.post("/api/user/login", data);
  },

  getRestaurantList(data) {
    //获取订餐公司列表
    return http.post("/api/Restaurant/restaurantH5List", data);
  },
  getOrderDetail(data) {
    //获取订餐单详情
    return http.post("/api/Restaurant/restaurantOrderInfo", data);
  },
  createRestaurantOrder(data) {
    //订餐
    return http.post("/api/Restaurant/restaurantOrder", data);
  },
  getRestaurantOrderList(data) {
    //获取订单列表
    return http.post("/api/Restaurant/restaurantOrderList", data);
  },
  getHolidays(data){
    //获取节假日
    return http.post("/api/Restaurant/getHolidays", data);
  },
  getEatTime(data){
    //获取订餐时间
    return http.post("/api/Restaurant/getEatTime", data);
  },
  submitAbsenceRequest(data){
    //提交停餐申请
    return http.post("/api/Restaurant/submitAbsenceRequest", data);
  },
  getAbsenceRequest(data){
    //获取停餐列表
    return http.post("/api/Restaurant/getAbsenceRequest", data);
  },

  getChildren() {
    //获取用户的孩子
    return http.get("/api/child/get");
  },
};
export default api;
